import { render, staticRenderFns } from "./DetailBdrPartenairesBbi.vue?vue&type=template&id=397a57d8&"
import script from "./DetailBdrPartenairesBbi.vue?vue&type=script&lang=js&"
export * from "./DetailBdrPartenairesBbi.vue?vue&type=script&lang=js&"
import style0 from "./DetailBdrPartenairesBbi.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports